import { render, staticRenderFns } from "./cardAntecedente.vue?vue&type=template&id=ab5d5632&"
import script from "./cardAntecedente.vue?vue&type=script&lang=js&"
export * from "./cardAntecedente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports